symbolWinBorderAnim = {};
symbolWinBorderAnim.reels = 5;
symbolWinBorderAnim.row = 7;
symbolWinBorderAnim.animsPlaying = [];
symbolWinBorderAnim.symbolsAnimating = [];
symbolWinBorderAnim.callback;
symbolWinBorderAnim.numberOfSymbolAnimationPlays = 0;
symbolWinBorderAnim.maxNumberOfSymbolAnimationPlays = 1;

symbolWinBorderAnim.create = function (json) {
  return new PIXI.Container();
};

symbolWinBorderAnim.initialise = function (json, container, resources) {
  symbolWinBorderAnim.container = container;

  for (var i = 0; i < symbolWinBorderAnim.reels; i++) {
    var rowList = [];

    for (var j = 0; j < symbolWinBorderAnim.row; j++) {
      var symbol = {};
      symbol.animation = resourceManager.createObject(
        "movie",
        "symbolBorderAnim_" + i + "_" + j,
        symbolWinBorderAnim.container,
        { definition: "symbolWinFrame", x: 0, y: 0, loop: false }
      );
      symbol.animation.gotoAndStop(0);
      symbol.animation.visible = false;
      rowList.push(symbol);
    }
    symbolWinBorderAnim.data.push(rowList);
  }

  messageBus.subscribe("spinner:GameConfigEvent", symbolWinBorderAnim.onLayoutComplete);
};

symbolWinBorderAnim.onLayoutComplete = function () {
  Reflex.registerEventHandler("orientationChange", symbolWinBorderAnim.onOrientationChange);
};

symbolWinBorderAnim.playAnimation = function (symbolsAnimating, callback) {
  symbolWinBorderAnim.callback = callback;
  // symbolWinBorderAnim.symbolsAnimating = symbolsAnimating;

  symbolWinBorderAnim.symbolsAnimating = symbolsAnimating.filter(
    (item, index, self) =>
      index ===
      self.findIndex(
        (t) => t.symbolId === item.symbolId && t.cell.reel === item.cell.reel && t.cell.row === item.cell.row
      )
  );

  for (var i = 0; i < symbolWinBorderAnim.symbolsAnimating.length; i++) {
    const reel = symbolWinBorderAnim.symbolsAnimating[i].cell.reel;
    const row = symbolWinBorderAnim.symbolsAnimating[i].cell.row;
    const symboPos = resourceManager.get("slotContainer:reelContainer:reel" + reel + ":symbol" + row);
    const reelPos = resourceManager.get("slotContainer:reelContainer:reel" + reel);

    const animation = resourceManager.createObject(
      "movie",
      `symbolBorderAnim_ ${symbolWinBorderAnim.animsPlaying.length}`,
      `slotContainer:reelContainer`,
      {
        definition: "symbolWinFrame",
        x: reelPos.position.x + symboPos.width / 2,
        y: reelPos.position.y + symboPos.position.y + symboPos.height / 2,
        loop: false,
        anchor: 0.5,
      }
    );

    animation.height = symboPos.height * 1.7;

    symbolWinBorderAnim.animsPlaying.push(animation);
    animation.gotoAndStop(0);
    animation.visible = true;
    animation.onComplete = () => {
      animation.alpha = 0;
    };
    animation.play();
  }

  // symbolAnimator.animate(
  //   symbolWinBorderAnim.symbolsAnimating,
  //   symbolWinBorderAnim.repeatSymbolAnimations.bind(this),
  //   0
  // );
  spineSymbolAnimator.animate(
    symbolWinBorderAnim.symbolsAnimating,
    symbolWinBorderAnim.repeatSymbolAnimations.bind(this),
    0
  );
};

symbolWinBorderAnim.onOrientationChange = async function () {
  await timerManager.delayAsync(0);
  for (var i = 0; i < symbolWinBorderAnim.symbolsAnimating.length && i < symbolWinBorderAnim.animsPlaying.length; i++) {
    const anim = symbolWinBorderAnim.animsPlaying[i];
    if (anim !== undefined) {
      const reel = symbolWinBorderAnim.symbolsAnimating[i].cell.reel;
      const row = symbolWinBorderAnim.symbolsAnimating[i].cell.row;
      const symboPos = resourceManager.get("slotContainer:reelContainer:reel" + reel + ":symbol" + row);
      const reelPos = resourceManager.get("slotContainer:reelContainer:reel" + reel);
      //anim.width = symboPos.width * 1.7;
      anim.position.setX(reelPos.position.x + symboPos.width / 2);
      anim.position.setY(reelPos.position.y + symboPos.position.y + symboPos.height / 2);
      anim.height = symboPos.height * 1.7;
    }
  }
};

symbolWinBorderAnim.repeatSymbolAnimations = function () {
  if (symbolWinBorderAnim.numberOfSymbolAnimationPlays < symbolWinBorderAnim.maxNumberOfSymbolAnimationPlays) {
    symbolWinBorderAnim.numberOfSymbolAnimationPlays++;
    // symbolAnimator.animate(
    //   symbolWinBorderAnim.symbolsAnimating,
    //   symbolWinBorderAnim.repeatSymbolAnimations.bind(this),
    //   0
    // );
    spineSymbolAnimator.animate(
      symbolWinBorderAnim.symbolsAnimating,
      symbolWinBorderAnim.repeatSymbolAnimations.bind(this),
      0
    );

    for (var i = 0; i < symbolWinBorderAnim.animsPlaying.length; i++) {
      const animation = symbolWinBorderAnim.animsPlaying[i];
      animation.alpha = 1;
      animation.onComplete = () => {
        animation.alpha = 0;
      };
      animation.gotoAndStop(0);
      animation.play();
    }
  } else {
    symbolWinBorderAnim.numberOfSymbolAnimationPlays = 0;
    symbolWinBorderAnim.stopAllAnimations();
  }
};

symbolWinBorderAnim.getFilesRequired = function (json) {
  return [];
};

symbolWinBorderAnim.stopAllAnimations = function () {
  for (var i = 0; i < symbolWinBorderAnim.animsPlaying.length; i++) {
    symbolWinBorderAnim.animsPlaying[i].visible = false;
    symbolWinBorderAnim.animsPlaying[i].gotoAndStop(0);
    resourceManager.destroyObject(symbolWinBorderAnim.animsPlaying[i].name);
  }
  symbolWinBorderAnim.animsPlaying = [];
  symbolWinBorderAnim.numberOfPlays = 0;
  if (symbolWinBorderAnim.callback !== undefined) {
    symbolWinBorderAnim.callback();
    symbolWinBorderAnim.callback = undefined;
  }
};

symbolWinBorderAnim.skip = function () {
  for (var i = 0; i < symbolWinBorderAnim.animsPlaying.length; i++) {
    symbolWinBorderAnim.animsPlaying[i].visible = false;
    symbolWinBorderAnim.animsPlaying[i].gotoAndStop(0);
    resourceManager.destroyObject(symbolWinBorderAnim.animsPlaying[i].name);
  }
  symbolWinBorderAnim.animsPlaying = [];
  symbolWinBorderAnim.numberOfPlays = 0;
  symbolWinBorderAnim.callback = undefined;
};

resourceManager.registerObjectType(
  "symbolWinBorderAnim",
  symbolWinBorderAnim.create,
  symbolWinBorderAnim.initialise,
  symbolWinBorderAnim.getFilesRequired
);
Reflex.registerEventHandler("orientationChange", symbolWinBorderAnim.onOrientationChange);
